"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#00b51e",
    d: "M9.871 10.587h4.289v1.688H9.871zm1.162 4.664h1.887l.595-2.039H10.4z"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "#00b51e",
    d: "M12.001 3.757a8.243 8.243 0 1 0 0 16.486 8.243 8.243 0 0 0 0-16.486m4.222 12.291H7.739v-.797h2.098l-.633-2.039h-.738V9.649h7.055v3.563h-.806l-.595 2.039h2.105v.797zm.023-7.289H7.785v-.938h8.461z"
  })]
}), 'Douban');
